import { Translation } from 'primeng/api';

export const primeNGPtBR: Translation = {
  startsWith: 'Começa com',
  contains: 'Contém',
  notContains: 'Não contém',
  endsWith: 'Termina com',
  equals: 'Igual a',
  notEquals: 'Diferente de',
  noFilter: 'Sem filtro',
  lt: 'Menor que',
  lte: 'Menor ou igual a',
  gt: 'Maior que',
  gte: 'Maior ou igual a',
  is: 'É',
  isNot: 'Não é',
  before: 'Antes',
  after: 'Depois',
  dateIs: 'Data é',
  dateIsNot: 'Data não é',
  dateBefore: 'Data é antes de',
  dateAfter: 'Data é depois de',
  clear: 'Limpar',
  apply: 'Aplicar',
  matchAll: 'Corresponder a todos',
  matchAny: 'Corresponder a qualquer',
  addRule: 'Adicionar regra',
  removeRule: 'Remover regra',
  accept: 'Sim',
  reject: 'Não',
  choose: 'Escolher',
  upload: 'Enviar',
  cancel: 'Cancelar',
  completed: 'Concluído',
  pending: 'Pendente',
  fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  dayNames: [
    'Domingo',
    'Segunda-feira',
    'Terça-feira',
    'Quarta-feira',
    'Quinta-feira',
    'Sexta-feira',
    'Sábado',
  ],
  dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  dayNamesMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sá'],
  monthNames: [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ],
  monthNamesShort: [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez',
  ],
  dateFormat: 'dd/mm/yy',
  firstDayOfWeek: 0,
  today: 'Hoje',
  weekHeader: 'Sem',
  weak: 'Fraca',
  medium: 'Média',
  strong: 'Forte',
  passwordPrompt: 'Digite uma senha',
  emptyMessage: 'Nenhum resultado encontrado',
  emptyFilterMessage: 'Nenhum resultado encontrado',
  emptySearchMessage: 'Nenhum resultado encontrado',
  emptySelectionMessage: 'Nenhum item selecionado',
  fileChosenMessage: '{0} arquivo(s) selecionado(s)',
  noFileChosenMessage: 'Nenhum arquivo selecionado',
  searchMessage: '{0} resultados disponíveis',
  selectionMessage: '{0} item(ns) selecionado(s)',
  chooseYear: 'Escolher ano',
  chooseMonth: 'Escolher mês',
  chooseDate: 'Escolher data',
  prevDecade: 'Década anterior',
  nextDecade: 'Próxima década',
  prevYear: 'Ano anterior',
  nextYear: 'Próximo ano',
  prevMonth: 'Mês anterior',
  nextMonth: 'Próximo mês',
  prevHour: 'Hora anterior',
  nextHour: 'Próxima hora',
  prevMinute: 'Minuto anterior',
  nextMinute: 'Próximo minuto',
  prevSecond: 'Segundo anterior',
  nextSecond: 'Próximo segundo',
  am: 'AM',
  pm: 'PM',
  aria: {
    trueLabel: 'Verdadeiro',
    falseLabel: 'Falso',
    nullLabel: 'Não selecionado',
    star: '1 estrela',
    stars: '{star} estrelas',
    selectAll: 'Selecionar todos',
    unselectAll: 'Desmarcar todos',
    close: 'Fechar',
    previous: 'Anterior',
    next: 'Próximo',
    navigation: 'Navegação',
    scrollTop: 'Rolar ao topo',
    moveTop: 'Mover ao topo',
    moveUp: 'Mover para cima',
    moveDown: 'Mover para baixo',
    moveBottom: 'Mover ao final',
    moveToTarget: 'Mover para o destino',
    moveToSource: 'Mover para a origem',
    moveAllToTarget: 'Mover todos para o destino',
    moveAllToSource: 'Mover todos para a origem',
    pageLabel: 'Página {page}',
    firstPageLabel: 'Primeira página',
    lastPageLabel: 'Última página',
    nextPageLabel: 'Próxima página',
    prevPageLabel: 'Página anterior',
    previousPageLabel: 'Página anterior',
    rowsPerPageLabel: 'Linhas por página',
    jumpToPageDropdownLabel: 'Ir para a página',
    jumpToPageInputLabel: 'Ir para a página',
    selectRow: 'Linha selecionada',
    unselectRow: 'Linha desmarcada',
    expandRow: 'Linha expandida',
    collapseRow: 'Linha recolhida',
    showFilterMenu: 'Exibir menu de filtros',
    hideFilterMenu: 'Ocultar menu de filtros',
    filterOperator: 'Operador de filtro',
    filterConstraint: 'Restrição de filtro',
    editRow: 'Editar linha',
    saveEdit: 'Salvar edição',
    cancelEdit: 'Cancelar edição',
    listView: 'Visualização em lista',
    gridView: 'Visualização em grade',
    slide: 'Slide',
    slideNumber: 'Slide {slideNumber}',
    zoomImage: 'Ampliar imagem',
    zoomIn: 'Mais zoom',
    zoomOut: 'Menos zoom',
    rotateRight: 'Girar à direita',
    rotateLeft: 'Girar à esquerda',
    listLabel: 'Lista de opções',
    selectColor: 'Selecionar cor',
    removeLabel: 'Remover',
    browseFiles: 'Procurar arquivos',
    maximizeLabel: 'Maximizar',
  },
};
